import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import './Inicio.css';
import { PageBase } from "../../Components/PageBase";
import { Loading } from "../../Components/UX/Loading";
import { useRol } from "../../Context";
import imgMovil from "../../icons/candidates-Vacants.png";
import personMovil from "../../icons/person.svg";
import potencialMovil from "../../icons/bar-chart.svg";
import cierresMovil from "../../icons/logo-usd.svg"
import congeladosMovil from "../../icons/snow.svg"
import { getOriginImage, getOriginLabel, calculateDateDifference, getEmojiImage, isDormido } from "../../utils/leadHelpers";

function Inicio() {
    const navigate = useNavigate();
    const {
        loading,
        rol,
        leads,
        counts,
        setActiveButton,
        tasksOpen,
        dataProfile,
        fecha,
        image,
        handleButtonClickIndicadores,
        listaUsers,
        Id,
        setRecruiterId,
        setPeriodo
    } = useRol();

    const handleTodosContactosClick = () => {
        handleButtonClickIndicadores(1)
        setActiveButton(1);
        navigate('/Contactos');
    };

    const handlePotencialesClick = () => {
        handleButtonClickIndicadores(5)
        setActiveButton(5);
        navigate('/Contactos');
    }

    const handleCierreClick = () => {
        handleButtonClickIndicadores(6)
        setActiveButton(6);
        navigate('/Contactos');
    };

    const handleCongeladosClick = () => {
        handleButtonClickIndicadores(7)
        setActiveButton(1);
        navigate('/Contactos');
    };

    const handleVerContactosAsesor = (userId) => {
        setRecruiterId(String(userId));
        navigate('/Contactos?stage=1');
    };

    const periodoMap = { todos: '00', '90dias': '90_dias', mes: '30_dias' };

    const handleNavigateConFiltro = (userId, buttonId) => {
        setActiveButton(buttonId);
        setRecruiterId(String(userId));
        const per = periodoMap[periodoEquipo] || '00';
        navigate(`/Contactos?stage=${buttonId}&periodo=${per}`);
    };

    const [lastActivities, setLastActivities] = useState({});
    const [periodoEquipo, setPeriodoEquipo] = useState('mes');
    const [rolEquipo, setRolEquipo] = useState('asesores');

    const filterLeadsByPeriodo = (leadsArr, periodo) => {
        if (periodo === 'todos' || !Array.isArray(leadsArr)) return leadsArr;
        const now = new Date();
        if (periodo === '90dias') {
            const cutoff = new Date();
            cutoff.setDate(cutoff.getDate() - 90);
            return leadsArr.filter(l => new Date(l.review_date) >= cutoff);
        }
        if (periodo === 'mes') {
            return leadsArr.filter(l => {
                const d = new Date(l.review_date);
                return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
            });
        }
        return leadsArr;
    };

    const cardCounts = (() => {
        if (!Array.isArray(leads)) return periodoEquipo === 'todos' ? counts : null;
        const filtered = filterLeadsByPeriodo(leads, periodoEquipo);
        return {
            total: filtered.length,
            potenciales: filtered.filter(l => l.contracting_status === 'Potencial').length,
            cierre: filtered.filter(l => l.contracting_status === 'Cierre').length,
            congelados: filtered.filter(l => {
                const diffDays = (new Date(l.review_date) - new Date()) / 86400000;
                return diffDays < -22 && l.contracting_status !== 'Cierre';
            }).length,
        };
    })();

    const asesorCardCounts = (() => {
        if (!Array.isArray(leads)) return null;
        const filtered = filterLeadsByPeriodo(leads.filter(l => l.recruiter === Id), periodoEquipo);
        return {
            total: filtered.length,
            potenciales: filtered.filter(l => l.contracting_status === 'Potencial').length,
            cierre: filtered.filter(l => l.contracting_status === 'Cierre').length,
            congelados: filtered.filter(l => {
                const diffDays = (new Date(l.review_date) - new Date()) / 86400000;
                return diffDays < -22 && l.contracting_status !== 'Cierre';
            }).length,
        };
    })();

    const asesorLast5Leads = (() => {
        if (!Array.isArray(leads)) return [];
        return leads.filter(l => l.recruiter === Id)
            .sort((a, b) => new Date(b.review_date) - new Date(a.review_date))
            .slice(0, 5);
    })();

    useEffect(() => {
        if ((rol !== 'Coordinador' && rol !== 'Supervisor' && rol !== 'Administrador') || !listaUsers || !leads || !Array.isArray(leads)) return;

        const asesores = listaUsers.filter(u => !u.is_staff && u.rol !== 'Coordinador' && u.rol !== 'Administrador');

        const fetchLastActivity = async (asesor) => {
            const asesorLeads = leads
                .filter(lead => lead.recruiter === asesor.id)
                .sort((a, b) => new Date(b.review_date) - new Date(a.review_date))
                .slice(0, 10);

            if (asesorLeads.length === 0) return;

            const noteArrays = await Promise.all(
                asesorLeads.map(lead =>
                    fetch(`${process.env.REACT_APP_API_URL || ""}/api/notes/byLeadId?lead=${lead.id}`)
                        .then(r => r.json())
                        .catch(() => [])
                )
            );

            const allNotes = noteArrays.flat().filter(n => n.user === asesor.id);
            if (allNotes.length === 0) return;

            allNotes.sort((a, b) => new Date(b.created) - new Date(a.created));
            setLastActivities(prev => ({ ...prev, [asesor.id]: allNotes[0].created }));
        };

        asesores.forEach(fetchLastActivity);
    }, [rol, listaUsers, leads]);

    let user = dataProfile ? dataProfile.first_name : "User";

    const filterTasksDueToday = (tasksOpen, fecha) => {
        if (!tasksOpen || !Array.isArray(tasksOpen)) {
            return [];
        }
        const tasksDueToday = tasksOpen.filter(task => isTaskDueToday(task, fecha));
        return tasksDueToday;
    };

    const isTaskDueToday = (task, fecha) => {
        const taskExpirationDate = new Date(task.expiration);
        const taskDueDate = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
        return areDatesEqual(taskExpirationDate, taskDueDate);
    };

    const areDatesEqual = (date1, date2) => {
        return (
            date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate()
        );
    };

    const tasksDueToday = filterTasksDueToday(tasksOpen, fecha);

    const getMedalIcon = (i) => {
        const configs = [
            { ribbon: '#E6A817', body: '#FFD700', ring: '#E6A817', shine: 'rgba(255,255,255,0.45)' },
            { ribbon: '#7A7A9A', body: '#D8D8F0', ring: '#AAAACC', shine: 'rgba(255,255,255,0.6)' },
            { ribbon: '#7D4A1E', body: '#CD7F32', ring: '#A0612A', shine: 'rgba(255,255,255,0.3)' },
            { ribbon: '#D4D4D4', body: '#F2F2F2', ring: '#E0E0E0', shine: 'rgba(255,255,255,0.5)' },
        ];
        const c = configs[Math.min(i, 3)];
        return (
            <svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="6" y="0" width="8" height="11" rx="2" fill={c.ribbon} />
                <circle cx="10" cy="19" r="7" fill={c.body} />
                <circle cx="10" cy="19" r="5.5" fill="none" stroke={c.ring} strokeWidth="1.2" />
                <circle cx="7.5" cy="16.5" r="1.5" fill={c.shine} />
            </svg>
        );
    };

    return (
        <>
            {loading ? <Loading /> :
                <PageBase>
                    <div className="main-content">
                        {(rol === 'Coordinador' || rol === 'Supervisor' || rol === 'Administrador') && (
                            <div className="margenV3-contactos coord-page-wrapper">
                                <div className="indicadores-coord-wrapper">
                                    <div className="indicadores-coord-header">
                                        <div className="indicadores-coord-header-text">
                                            <label>Avance de tus contactos</label>
                                            <span>{"Este es el estatus de tus contactos durante " + { todos: 'todo el periodo', '90dias': 'los últimos 90 días', mes: 'el último mes' }[periodoEquipo]}</span>
                                        </div>
                                        <select
                                            className="equipo-periodo-select"
                                            value={periodoEquipo}
                                            onChange={e => setPeriodoEquipo(e.target.value)}
                                        >
                                            <option value="todos">Todos los contactos</option>
                                            <option value="90dias">Últimos 90 días</option>
                                            <option value="mes">Último mes</option>
                                        </select>
                                    </div>
                                    <div className="indicadores-coord">
                                        <div className="card-coord" onClick={handleTodosContactosClick}>
                                            <span className="card-coord-number">{leads === null ? <span className="equipo-stat-loader" /> : (cardCounts ? cardCounts.total : 0)}</span>
                                            <span className="card-coord-action">Contactos generados</span>
                                        </div>
                                        <div className="card-coord" onClick={handlePotencialesClick}>
                                            <span className="card-coord-number">{leads === null ? <span className="equipo-stat-loader" /> : (cardCounts ? cardCounts.potenciales : 0)}</span>
                                            <span className="card-coord-action">Potenciales clientes</span>
                                        </div>
                                        <div className="card-coord" onClick={handleCierreClick}>
                                            <span className="card-coord-number">{leads === null ? <span className="equipo-stat-loader" /> : (cardCounts ? cardCounts.cierre : 0)}</span>
                                            <span className="card-coord-action">Cierres de venta</span>
                                        </div>
                                        <div className="card-coord" onClick={handleCongeladosClick}>
                                            <span className="card-coord-number">{leads === null ? <span className="equipo-stat-loader" /> : (cardCounts ? cardCounts.congelados : 0)}</span>
                                            <span className="card-coord-action">Sin intentos de contacto</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="asesores-container">
                                    <div className="asesores-title">
                                        <div className="asesores-title-row">
                                            <div className="indicadores-coord-header-text">
                                                <label>Seguimiento de tu equipo</label>
                                                <span>Aquí podrás ver el seguimiento de tu equipo a los contactos que se han generado</span>
                                            </div>
                                            <select
                                                className="equipo-periodo-select"
                                                value={rolEquipo}
                                                onChange={e => setRolEquipo(e.target.value)}
                                            >
                                                <option value="todos">Todos los usuarios</option>
                                                <option value="asesores">Solo asesores</option>
                                                <option value="coordinadores">Solo coordinadores</option>
                                            </select>
                                        </div>
                                        <hr />
                                    </div>
                                    <div className="asesores-list">
                                        <table className="equipo-table">
                                            <tbody>
                                                {(() => {
                                                    const leadsLoading = leads === null;
                                                    const leadsError = !leadsLoading && !Array.isArray(leads);
                                                    const periodLeads = (!leadsLoading && !leadsError) ? filterLeadsByPeriodo(leads, periodoEquipo) : [];

                                                    const getOrdinal = (i) => `${i + 1}a`;

                                                    const filteredUsers = (listaUsers || []).filter(u => {
                                                        if (u.is_staff || u.rol === 'Administrador') return false;
                                                        if (rolEquipo === 'asesores') return u.rol !== 'Coordinador';
                                                        if (rolEquipo === 'coordinadores') return u.rol === 'Coordinador';
                                                        return true;
                                                    });

                                                    const usersWithStats = filteredUsers.map(u => {
                                                        const al = (!leadsLoading && !leadsError) ? periodLeads.filter(l => l.recruiter === u.id) : null;
                                                        return {
                                                            user: u,
                                                            stats: al ? {
                                                                contactos: al.length,
                                                                citas: al.filter(l => l.contracting_status === 'Cita').length,
                                                                visitas: al.filter(l => l.contracting_status === 'Visita').length,
                                                                cierres: al.filter(l => l.contracting_status === 'Cierre').length,
                                                            } : null,
                                                        };
                                                    });

                                                    const sorted = [...usersWithStats].sort((a, b) =>
                                                        (b.stats?.contactos ?? -1) - (a.stats?.contactos ?? -1)
                                                    );

                                                    return sorted.map(({ user, stats }, index) => {
                                                        const statCell = (value, label, buttonId) => leadsLoading
                                                            ? <span className="equipo-stat-loader" />
                                                            : stats === null
                                                                ? <span className="equipo-actividad-label">N/A</span>
                                                                : <span className="lead-date-format-v3-1 equipo-stat-link" onClick={() => handleNavigateConFiltro(user.id, buttonId)}>{value} {label}</span>;

                                                        return (
                                                            <tr key={user.id}>
                                                                <td>
                                                                    <div className="equipo-asesor-cell">
                                                                        <div className="equipo-asesor-avatar">
                                                                            {user.first_name?.[0]?.toUpperCase()}{user.last_name?.[0]?.toUpperCase()}
                                                                        </div>
                                                                        <div className="equipo-asesor-info">
                                                                            <label>{user.first_name + ' ' + user.last_name}</label>
                                                                            <span>{user.is_staff ? 'Administrador' : (user.rol || 'Asesor')}</span>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="equipo-position-cell">
                                                                    {getMedalIcon(index)}
                                                                    <span className="equipo-position">{getOrdinal(index)} posición</span>
                                                                </td>
                                                                <td>{statCell(stats?.contactos, 'contactos', 1)}</td>
                                                                <td>{statCell(stats?.citas, 'citas', 3)}</td>
                                                                <td>{statCell(stats?.visitas, 'visitas', 4)}</td>
                                                                <td>{statCell(stats?.cierres, 'cierres', 6)}</td>
                                                                <td>
                                                                    {lastActivities[user.id] ? (
                                                                        <div className="equipo-actividad">
                                                                            <span>{dayjs(lastActivities[user.id]).format('DD/MM/YY - HH:mm')}</span>
                                                                            <span className="equipo-actividad-label">Última actividad</span>
                                                                        </div>
                                                                    ) : (
                                                                        <span className="equipo-actividad-label">Sin actividad</span>
                                                                    )}
                                                                </td>
                                                                <td><button className="equipo-table-btn" onClick={() => handleVerContactosAsesor(user.id)}>Ver contactos</button></td>
                                                            </tr>
                                                        );
                                                    });
                                                })()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}
                        {rol === 'Asesor' && (
                            <div className="margenV3-contactos coord-page-wrapper asesor-coord-page">
                                <div className="indicadores-coord-wrapper">
                                    <div className="indicadores-coord-header">
                                        <div className="indicadores-coord-header-text">
                                            <label>Avance de tus contactos</label>
                                            <span>{"Este es el estatus de tus contactos durante " + { todos: 'todo el periodo', '90dias': 'los últimos 90 días', mes: 'el último mes' }[periodoEquipo]}</span>
                                        </div>
                                        <select
                                            className="equipo-periodo-select"
                                            value={periodoEquipo}
                                            onChange={e => setPeriodoEquipo(e.target.value)}
                                        >
                                            <option value="todos">Todos los contactos</option>
                                            <option value="90dias">Últimos 90 días</option>
                                            <option value="mes">Último mes</option>
                                        </select>
                                    </div>
                                    <div className="indicadores-coord">
                                        <div className="card-coord" onClick={handleTodosContactosClick}>
                                            <span className="card-coord-number">{leads === null ? <span className="equipo-stat-loader" /> : (asesorCardCounts ? asesorCardCounts.total : 0)}</span>
                                            <span className="card-coord-action">Contactos generados</span>
                                        </div>
                                        <div className="card-coord" onClick={handlePotencialesClick}>
                                            <span className="card-coord-number">{leads === null ? <span className="equipo-stat-loader" /> : (asesorCardCounts ? asesorCardCounts.potenciales : 0)}</span>
                                            <span className="card-coord-action">Potenciales clientes</span>
                                        </div>
                                        <div className="card-coord" onClick={handleCierreClick}>
                                            <span className="card-coord-number">{leads === null ? <span className="equipo-stat-loader" /> : (asesorCardCounts ? asesorCardCounts.cierre : 0)}</span>
                                            <span className="card-coord-action">Cierres de venta</span>
                                        </div>
                                        <div className="card-coord" onClick={handleCongeladosClick}>
                                            <span className="card-coord-number">{leads === null ? <span className="equipo-stat-loader" /> : (asesorCardCounts ? asesorCardCounts.congelados : 0)}</span>
                                            <span className="card-coord-action">Sin intentos de contacto</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="asesor-bottom-row">
                                    <div className="asesores-container asesor-half">
                                        {(() => {
                                            const filteredUsers = (listaUsers || []).filter(u => {
                                                if (u.is_staff || u.rol === 'Administrador') return false;
                                                return u.rol !== 'Coordinador';
                                            });
                                            const hasUsersWithLeads = Array.isArray(leads) && filteredUsers.some(u => leads.some(l => l.recruiter === u.id));

                                            if (!hasUsersWithLeads) {
                                                return (
                                                    <div className="col-panel-task-right-empty">
                                                        <img src="/static/v2/vendor/img/challenge.png" alt="empty" style={{ width: '100%', maxWidth: '360px' }} />
                                                        <div className="col-panel-task-empty-text">
                                                            <label>Aun no hay miembros en el equipo</label>
                                                            <span>Tan pronto como el equipo de seguimiento a sus contactos, podrás compararlo con el tuyo.</span>
                                                        </div>
                                                    </div>
                                                );
                                            }

                                            const leadsLoading = leads === null;
                                            const periodLeads = Array.isArray(leads) ? filterLeadsByPeriodo(leads, periodoEquipo) : [];
                                            const getOrdinal = (i) => `${i + 1}a`;

                                            const usersWithStats = filteredUsers.map(u => {
                                                const al = Array.isArray(leads) ? periodLeads.filter(l => l.recruiter === u.id) : null;
                                                return {
                                                    user: u,
                                                    stats: al ? {
                                                        contactos: al.length,
                                                        cierres: al.filter(l => l.contracting_status === 'Cierre').length,
                                                    } : null,
                                                };
                                            });

                                            const sorted = [...usersWithStats].sort((a, b) =>
                                                (b.stats?.contactos ?? -1) - (a.stats?.contactos ?? -1)
                                            );

                                            return (
                                                <>
                                                    <div className="asesores-title">
                                                        <div className="asesores-title-row">
                                                            <div className="indicadores-coord-header-text">
                                                                <label>Posición en el equipo</label>
                                                                <span>Tu posición y cierres durante el período seleccionado</span>
                                                            </div>
                                                        </div>
                                                        <hr />
                                                    </div>
                                                    <div className="asesores-list">
                                                        <table className="equipo-table">
                                                            <tbody>
                                                                {sorted.map(({ user, stats }, index) => (
                                                                    <tr key={user.id} className={user.id === Id ? 'asesor-row-highlight' : ''}>
                                                                        <td>
                                                                            <div className="equipo-asesor-cell">
                                                                                <div className="equipo-asesor-avatar">
                                                                                    {user.first_name?.[0]?.toUpperCase()}{user.last_name?.[0]?.toUpperCase()}
                                                                                </div>
                                                                                <div className="equipo-asesor-info">
                                                                                    <label>{user.first_name + ' ' + user.last_name}</label>
                                                                                    <span>{user.rol || 'Asesor'}</span>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td className="equipo-position-cell">
                                                                            {getMedalIcon(index)}
                                                                            <span className="equipo-position">{getOrdinal(index)} posición</span>
                                                                        </td>
                                                                        <td>
                                                                            {leadsLoading
                                                                                ? <span className="equipo-stat-loader" />
                                                                                : stats === null
                                                                                    ? <span className="equipo-actividad-label">N/A</span>
                                                                                    : <span className="lead-date-format-v3-1">{stats.cierres} cierres</span>
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </>
                                            );
                                        })()}
                                    </div>
                                    <div className="asesor-contactos asesor-half">
                                        {asesorLast5Leads.length > 0 && (
                                            <div className="asesores-title">
                                                <div className="asesores-title-row">
                                                    <div className="indicadores-coord-header-text">
                                                        <label>Últimos contactos</label>
                                                        <span>Tus 5 contactos más recientes por seguimiento</span>
                                                    </div>
                                                </div>
                                                <hr />
                                            </div>
                                        )}
                                        {asesorLast5Leads.length === 0 ? (
                                            <div className="col-panel-task-right-empty">
                                                <img src="/static/v2/vendor/img/study_girl.jpg" alt="empty" style={{ width: '100%', maxWidth: '360px' }} />
                                                <div className="col-panel-task-empty-text">
                                                    <label>Comienza a gestionar a tus contactos</label>
                                                    <span>Si aun no tienes contactos de anuncios o captación automática comienza aquí.</span>
                                                </div>
                                                <button className="equipo-table-btn" onClick={() => navigate('/Contactos')}>Crear mi primer contacto</button>
                                            </div>
                                        ) : (
                                            <div className="asesores-list">
                                                <table className="equipo-table">
                                                    <tbody>
                                                        {asesorLast5Leads.map(lead => {
                                                            const diff = calculateDateDifference(lead.review_date);
                                                            const dormido = isDormido(diff, lead.contracting_status);
                                                            return (
                                                                <tr key={lead.id}>
                                                                    <td>
                                                                        <div className="asesor-contactos-origin">
                                                                            <img src={getOriginImage(lead.origin)} alt={lead.origin} title={lead.origin} />
                                                                            <span className="equipo-actividad-label">{getOriginLabel(lead.origin)}</span>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="asesor-contactos-emoji-col">
                                                                            {dormido
                                                                                ? <span style={{ fontSize: '20px', lineHeight: 1 }}>😴</span>
                                                                                : <img src={getEmojiImage(diff, lead.contracting_status)} alt="" style={{ width: '20px', height: '20px' }} />
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ textAlign: 'left' }}>
                                                                        <div className="asesor-contactos-name">
                                                                            <label>{lead.candidate_name}</label>
                                                                            <span className="equipo-actividad-label">
                                                                                {lead.postulation_date ? dayjs(lead.postulation_date).format('DD/MM/YY') : '—'}
                                                                            </span>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <span className="asesor-stage-pill">{lead.contracting_status || '—'}</span>
                                                                    </td>
                                                                    <td>
                                                                        <div className="asesor-last-contact">
                                                                            <span className="equipo-actividad-label">Último contacto</span>
                                                                            <span>{lead.review_date ? dayjs(lead.review_date).format('DD/MM/YY') : '—'}</span>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="inicio-movil">
                        <div className="container-main-movil">
                            {rol === 'Asesor' && <div>
                                <div className="inicio-container-cards-movil">
                                    <div className="home-card-movil" onClick={handleTodosContactosClick}>
                                        <label>Contactos</label>
                                        <hr />
                                        {counts && leads && Array.isArray(leads) ? (
                                            <span>{leads.filter(lead => lead.recruiter === Id).length}</span>
                                        ) : (
                                            <span>0</span>
                                        )}
                                    </div>
                                    <div className="home-card-movil" onClick={() => handlePotencialesClick()}>
                                        <label>Potenciales</label>
                                        <hr />
                                        {counts ? (
                                            <span>{counts.potenciales}</span>
                                        ) : (
                                            <span>0</span>
                                        )}
                                    </div>
                                    <div className="home-card-movil" onClick={() => handleCierreClick()}>
                                        <label>Cierres</label>
                                        <hr />
                                        {counts ? (
                                            <span>{counts.cierre}</span>
                                        ) : (
                                            <span>0</span>
                                        )}
                                    </div>
                                    <div className="home-card-movil" onClick={() => handleCongeladosClick()}>
                                        <label>Congelados</label>
                                        <hr />
                                        {counts ? (
                                            <span>{counts.congelados}</span>
                                        ) : (
                                            <span>0</span>
                                        )}
                                    </div>
                                </div>
                                <div className="tareas-today-movil">
                                    <div className="title-today-movil">
                                        <label>Tareas del diá</label>
                                    </div>
                                    {tasksDueToday && tasksDueToday.length > 0 ? (
                                        tasksDueToday
                                            .filter(task => new Date(task.expiration) < fecha)
                                            .map(task => (
                                                <NavLink to="/Tareas" className="nav-links-movil-inicio" key={task.id}>
                                                    <div className="item-tarea-movil">
                                                        <label>{task.title}</label>
                                                        <div className="container-date-movil">
                                                            <label>{new Date(task.expiration).toLocaleDateString()}</label>
                                                        </div>
                                                    </div>
                                                </NavLink>
                                            ))
                                    ) : (
                                        <div className="container-today-movil">
                                            <div className="description-today-movil">
                                                <h4>Sin tareas creadas</h4>
                                                <p>Comienza creando una nueva tarea</p>
                                            </div>
                                            <div className="img-today-movil">
                                                <img src={imgMovil} alt="candidates-vacant.png" key={1} />
                                            </div>
                                        </div>
                                    )
                                    }
                                </div>
                                <div className="tareas-venced-movil">
                                    <div className="title-venced-movil">
                                        <label>Tareas vencidas</label>
                                    </div>
                                    <div className="container-venced-movil">
                                        {tasksOpen && Array.isArray(tasksOpen) ? tasksOpen
                                            .filter(task => new Date(task.expiration) < fecha)
                                            .map(task => (
                                                <NavLink to={'/Tareas'} className='nav-links-movil-inicio' key={task.id}>
                                                    <div className="item-tarea-movil">
                                                        <label>{task.title}</label>
                                                        <div className="container-date-movil">
                                                            <label>{task.expiration}</label>
                                                        </div>
                                                    </div>
                                                </NavLink>
                                            )) : null
                                        }
                                    </div>
                                </div>
                            </div>}
                            {(rol === 'Coordinador' || rol === 'Supervisor' || rol === 'Administrador') && <div>
                                <div className="inicio-container-cards-movil">
                                    <div className="home-card-movil">
                                        <div className="home-card-icons-movil">
                                            <img src={personMovil} alt="personMovil" />
                                        </div>
                                        <span>0</span>
                                        <label>Contactos</label>
                                    </div>
                                    <div className="home-card-movil">
                                        <div className="home-card-icons-movil">
                                            <img src={personMovil} alt="personMovil" />
                                            <img className="dos" src={potencialMovil} alt="potencialMovil" />
                                        </div>
                                        <span>0</span>
                                        <label>Potenciales</label>
                                    </div>
                                    <div className="home-card-movil">
                                        <div className="home-card-icons-movil">
                                            <img src={personMovil} alt="personMovil" />
                                            <img className="dos" src={cierresMovil} alt="cierresMovil" />
                                        </div>
                                        <span>0</span>
                                        <label>Cierres</label>
                                    </div>
                                    <div className="home-card-movil">
                                        <div className="home-card-icons-movil">
                                            <img src={personMovil} alt="personMovil" />
                                            <img className="dos" src={congeladosMovil} alt="congeladosMovil" />
                                        </div>
                                        <span>0</span>
                                        <label>Congelados</label>
                                    </div>
                                    <div className="home-coord-title-movil">
                                        <label>Todos los asesores</label>
                                    </div>
                                    <div className="home-coord-card-asesor-movil">
                                        <div className="card-asesor-name-movil">
                                            <label>Carlos Ruis</label>
                                        </div>
                                        <div className="card-asesor-data-movil">
                                            <div className="asesor-data-etap-movil">
                                                <span>1</span>
                                                <label>Contactos</label>
                                            </div>
                                            <div className="asesor-data-etap-movil">
                                                <span>0</span>
                                                <label>Visitas</label>
                                            </div>
                                            <div className="asesor-data-etap-movil">
                                                <span>0</span>
                                                <label>Cierres</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                </PageBase>
            }
        </>
    )
}



export { Inicio }
